import "antd/dist/reset.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/style.css";
import "./App.css";
import { ConfigProvider } from "antd";
import AuthRoutes from "./routes/authRoutes.js";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ApiAuthProvider } from "./context/api-auth-context";

function App() {
  return (
    <ApiAuthProvider>
      <Provider store={store}>
        <ConfigProvider
          wave={{ disabled: true }}
          theme={{
            token: {
              colorPrimary: "#005CA9",
            },
            components: {
              Table: {
                colorFillAlter: "rgba(0, 0, 0, 0.06)",
                fontWeightStrong: 700,
              },
            },
          }}
        >
          <div className="App">
            <AuthRoutes />
          </div>
        </ConfigProvider>
      </Provider>
    </ApiAuthProvider>
  );
}

export default App;
